import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';
import { Notice, ErrorNotice, Loading, Field, TextInput } from '../components/Bits.tsx';
import { useSession } from '../App.tsx';

/** Shown after signing in with a mailed temporary password. */
export function NewPassword() {
  const { data, isPending } = useSession();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [mismatch, setMismatch] = useState(false);

  const save = useMutation({
    mutationFn: () => api.post('/api/password', { password }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['session'] });
      navigate('/apply');
    },
  });

  if (isPending) return <main className="narrow" id="main"><Loading /></main>;
  if (!data?.applicant) return <Navigate to="/" replace />;

  return (
    <main className="narrow" id="main">
      <h2>Choose a new password</h2>
      <Notice kind="info">
        You signed in with a temporary password. Choose one of your own to carry on.
      </Notice>

      <ErrorNotice error={save.error} />
      {mismatch && <Notice kind="error">Those two passwords do not match.</Notice>}

      <form
        className="panel"
        onSubmit={(e) => {
          e.preventDefault();
          if (password !== confirm) { setMismatch(true); return; }
          setMismatch(false);
          save.mutate();
        }}
      >
        <Field label="New password" hint="At least 8 characters.">
          <TextInput type="password" value={password} required minLength={8}
                 autoComplete="new-password" onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Field label="Confirm new password">
          <TextInput type="password" value={confirm} required
                 autoComplete="new-password" onChange={(e) => setConfirm(e.target.value)} />
        </Field>
        <div className="actions">
          <button type="submit" disabled={save.isPending}>
            {save.isPending ? 'Saving…' : 'Save password'}
          </button>
        </div>
      </form>
    </main>
  );
}
